import axios from "axios";
import { T, APIS } from "../../Constants";

type ItemHistory = T.API.ToAxios<T.API.Utils.Edits.ItemHistory>;
type CertifyValue = T.API.ToAxios<T.API.Utils.Edits.CertifyValue>;

/** Retrieve context info and prop history for an item */
export const itemHistory: ItemHistory = params => axios.post(APIS.EDITS_API + "history", params);
/** Certify a value, from the frontend to the backend */
export const certifyValue: CertifyValue = params => axios.post(APIS.EDITS_API + "certify", params);